jQuery(initMenuLanguages);

function initMenuLanguages($) {
  initToggleDropdownIcon();

  function initToggleDropdownIcon() {
    const $button = $("#languageDropdownButton");
    const $icon = $("#languageDropdownIcon");

    if (!$button.length || !$icon.length) return;

    $button.on("click", function () {
      if ($icon.hasClass("rotate-180")) {
        $icon.removeClass("rotate-180");
      } else {
        $icon.addClass("rotate-180");
      }
    });
  }
}
